import { useContext } from 'react';

import type { LeadCardContextValue } from '@app/components/LeadCard/context/hooks/useProviderValue';
import { LeadCardContext } from '@app/components/LeadCard/context/LeadCardContext';

export const useLeadCardContext = (): LeadCardContextValue => {
  const context = useContext(LeadCardContext);

  if (!context) {
    throw new Error(
      'useLeadCardContext must be used within a LeadCardProvider'
    );
  }

  return context;
};
